import { DocumentNode, gql } from '@apollo/client'

export const LINK_DAYCARE_TO_GROUP: DocumentNode = gql`
    mutation linkDaycareToGroup($groupId: Int!, $daycareId: Int!) {
        linkDaycareToGroup(groupId: $groupId, daycareId: $daycareId)
    }
`

export const UNLINK_DAYCARE_FROM_GROUP: DocumentNode = gql`
    mutation unlinkDaycareFromGroup($daycareId: Int!) {
        unlinkDaycareFromGroup(daycareId: $daycareId)
    }
`
